var _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoPython = function SvgLogoPython(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.886 5.742S12.096.045 24.756.045c13.231 0 12.209 6.87 12.209 6.87v11.35c0 6.865-6.732 6.752-6.732 6.752H18.25c-7.186 0-6.959 7.338-6.959 7.338v6.152h-4.22S0 38.977 0 25.72c0-13.256 8.102-12.303 8.102-12.303h16.88v-1.772H12.9l-.014-5.903Zm7.382.524c-.001-1.245-.974-2.253-2.174-2.252h-.004c-1.199.001-2.17 1.011-2.17 2.256v.004c.002 1.244.975 2.252 2.174 2.251h.004c1.2-.001 2.17-1.01 2.17-2.255v-.004Z",
    fill: "url(#logo-python_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.986 45.832s.79 5.697-11.87 5.697c-13.232 0-12.21-6.87-12.21-6.87V33.31c0-6.866 6.733-6.753 6.733-6.753h11.983c7.186 0 6.958-7.338 6.958-7.338v-6.151h4.22s7.072-.47 7.072 12.786c0 13.257-8.102 12.304-8.102 12.304H24.89v1.772h12.082l.014 5.903Zm-7.382-.523c.001 1.244.974 2.252 2.174 2.251h.004c1.199-.001 2.17-1.011 2.17-2.256V45.3c-.002-1.244-.975-2.252-2.174-2.251h-.005c-1.199.001-2.17 1.011-2.169 2.256v.004Z",
    fill: "url(#logo-python_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-python_svg__a",
    x1: -7.476,
    y1: 17.613,
    x2: 18.144,
    y2: 42.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-python_svg__b",
    x1: 7.256,
    y1: 34.828,
    x2: 34.726,
    y2: 59.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })))));
};

export default SvgLogoPython;